module.exports = __webpack_public_path__ + "img/img-08.60fb74fd.jpg";